import(/* webpackMode: "eager", webpackExports: ["default","LegacyContent","LongFormContent"] */ "/vercel/path0/apps/www/app/[locale]/(site)/(en-only)/resources/components/single-resource-content/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/www/components/newsletter-signup-form/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","src"] */ "/vercel/path0/node_modules/@hashicorp/flight-icons/svg-sprite/svg-sprite.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/react-components/src/components/product-badge/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/react-components/src/components/card/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/react-components/src/components/card/newsroom-card/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/react-components/src/components/card/person-card/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/react-components/src/components/related-content/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/app/[locale]/(site)/(en-only)/resources/components/single-resource-page-header/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/app/[locale]/(site)/(en-only)/resources/[slug]/style.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/app/[locale]/(site)/(en-only)/resources/components/newsletter-section/newsletter-section.module.css");
